import axios from 'axios';
import { getData, postData, putData } from './redux_data';
import {
    GET_CENTROS, GET_CENTRO, MODIFY_FIELD_DETALLE_CENTRO, MODIFY_FIELDS_CENTRO_DIALOG, UPDATE_CENTRO, COPY_CENTRO, CREATE_CENTRO, DELETE_CENTRO,//centros
    OPEN_DIALOG
} from '../constants/action_types';

import * as config from '../constants/configuration';



export function getAllCentros() {
    return getData('vcentros?includeGroups=true', GET_CENTROS);
}

export function copyCentroDB(id, newName, euros, tokens) {

    return postData('centros/?source=' + id, COPY_CENTRO, { descr: newName, fondoEuros: euros, fondoTokens: tokens }, undefined, undefined);

};

export function createNewCentroDB(newName, empresa, grupo, thenHandler, euros, tokens) {

    return postData('centros', CREATE_CENTRO, { descr: newName, empresaId: empresa, isGroup: grupo, fondoEuros: euros, fondoTokens: tokens }, undefined, thenHandler);

};

export function updateCentroDB(centro, id, thenHandler) {

    return putData('centros', UPDATE_CENTRO, centro, id, 'Datos del centro guardados', thenHandler);

};

export function deleteCentroDB(id) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_CENTRO, payload: id })
        let token = getState().oidc.user ? getState().oidc.user.access_token : "";
        axios.delete(config.API_URI() + 'centros/' + id,
            {
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        ).then((response) => {
            dispatch({ type: DELETE_CENTRO + "_SUCCESS", payload: response })
        }).catch((error) => {
            if (error.response.status === 409) {
                dispatch({
                    type: OPEN_DIALOG,
                    modalType: 'SimpleMessage',
                    modalProps: { message: error.response.data.message, exception: error.response.data.ex },
                    dialogid: 'error_delete_centro_' + id
                });
            }
            else {
                dispatch({
                    type: OPEN_DIALOG,
                    modalType: 'SimpleMessage',
                    modalProps: { message: error.response.data.message, exception: error.response.data.ex },
                    dialogid: 'error_delete_centro_' + id
                });
            }
        });
    };
};

export function getCentroDetalle(id) {
    return getData('centros/' + id, GET_CENTRO);
};

export function modifyFieldDetalleCentro(field, value) {
    return dispatch => {
        dispatch({ type: MODIFY_FIELD_DETALLE_CENTRO, payload: [field, value] })
    };
};

export function modifyFieldsCentroDialog(details) {
    return dispatch => {
        dispatch({ type: MODIFY_FIELDS_CENTRO_DIALOG, payload: details })
    };
};